export class pdfMakeChinese{
    public static vfs = {
    "Roboto-Italic.ttf": "",
    "Roboto-Medium.ttf": "",
    "Roboto-MediumItalic.ttf": "",
    "Roboto-Regular.ttf": ""
  }
}


// WEBPACK FOOTER //
// ./src/app/common/pdf/chinese-fonts.ts